<script>
    export let date_entry;
    export let u;
    export let yesterday;
    export let admin = false
    export let user_month_days = []
    import { _ } from 'svelte-i18n';
    import { url } from '../stores/url.js';
    import { user } from '../stores/user.js';
    import { users } from '../stores/users.js';
    import { date, hhmm, padNumber } from '../functions/html-helpers';
    import { getUsers, request } from '../functions/http-helpers.js';
    import { onMount } from 'svelte';
    import uikit from 'uikit';
    import { createEventDispatcher } from 'svelte';
    import { detach } from 'svelte/internal';
  


    /* SETUP */
    const dispatch = createEventDispatcher();
    onMount(() => {
        uikit.tooltip('[data-uk-tooltip]');
    });
    $: tooltip = renderTooltip(userDateTimeEntry);
    function renderTooltip() {
        if(userDateTimeEntry) {
            let str = '';
            if(userDateTimeEntry.end_time) {
                str += `${date('H:i', new Date(userDateTimeEntry.start_time))}`;
                str += ` - `;
                str += `${date('H:i', new Date(userDateTimeEntry.end_time))}`;
            }
            if(userDateTimeEntry.end_time2) {
                str += `<br>`;
                str += `${date('H:i', new Date(userDateTimeEntry.start_time2))}`;
                str += ` - `;
                str += `${date('H:i', new Date(userDateTimeEntry.end_time2))}`;
            }
            if(userDateTimeEntry.minutes_worked && $user.superuser) {
                str += `<br>`;
                str += `${(userDateTimeEntry.minutes_worked / 60).toFixed(1)}`;
            }
            return str; 
        }
        return '';
    }



    /* WATCH */
    $: userDateTimeEntry = getUserTimeEntry(u, date_entry);
    function getUserTimeEntry() {
        if(!admin) {
            return user_month_days.find(umd => umd.start_time && (date('Y-m-d', new Date(umd.start_time)) == date('Y-m-d', date_entry)));
        } else {
            return u.days.find(umd => umd.start_time && (date('Y-m-d', new Date(umd.start_time)) == date('Y-m-d', date_entry)));
        }
        
    }

    $: userDateTimeEntryBackgound = validateUserDateTimeEntry(userDateTimeEntry);
    function validateUserDateTimeEntry() {
        if(date_entry.getDay() == 0 || date_entry.getDay() == 6) { // sonntag
            return 'green';
        } else if(userDateTimeEntry?.start_time && userDateTimeEntry?.end_time) {
            return 'green';
        } else if(userDateTimeEntry?.faz_day) {
            return 'green';  
        } else if(userDateTimeEntry?.public_holiday) {
            return 'green'; 
        } else if(userDateTimeEntry?.vacation_day) {
            return 'green';
        } else if(userDateTimeEntry?.sick_day) {
            return 'green';
        } else if(userDateTimeEntry?.short_work) {
            return 'green';
        } else if(date_entry.getTime() < yesterday.getTime()) { 
            return 'red';
        }
    }   


    /* Events */
    function editDay() {
        console.log('editDay');
        console.log(userDateTimeEntry);
        dispatch('editDay', userDateTimeEntry); 
    }
</script> 



<div class="user-date-time-entry uk-display-inline-block uk-text-center" style="background-color: {userDateTimeEntryBackgound}; width: 50px !important; min-width: 50px !important" on:click={() => editDay()}>
    {#if userDateTimeEntry?.id}
        {#if userDateTimeEntry?.public_holiday}
            <span>FTG</span>   
        {:else if userDateTimeEntry?.faz_day && !userDateTimeEntry.end_time}
            <span>ÜSTD</span>  
        {:else if userDateTimeEntry?.vacation_day}
            <span>URLB</span> 
        {:else if userDateTimeEntry?.sick_day}
            <span>KRNK</span>  
        {:else if userDateTimeEntry?.short_work}
            <span>WA</span> 
        {:else}
            <span  
                data-uk-tooltip="title: {tooltip}"> 
                <!--
                    title: {date('H:i', new Date(userDateTimeEntry.start_time))} - {userDateTimeEntry.end_time ? date('H:i', new Date(userDateTimeEntry.end_time)) : ''} Uhr
                    {userDateTimeEntry.start_time2 ? '<br>' : ''}
                    {userDateTimeEntry.start_time2 ? date('H:i', new Date(userDateTimeEntry.start_time2)) : ''} 
                        -  
                    {userDateTimeEntry.end_time2 ? date('H:i', new Date(userDateTimeEntry.end_time2)) : ''} {userDateTimeEntry.start_time2 ? 'Uhr' : ''} -->
                {padNumber(parseInt(userDateTimeEntry.minutes_worked / 60))}:{padNumber(parseInt(userDateTimeEntry.minutes_worked % 60))} 
            </span>
        {/if} 
    {:else}
        <span>&nbsp;</span>
    {/if}
</div>


<style>
    .user-date-time-entry:hover{
        background-color: rgb(0, 0, 0) !important;
    }
</style>